<udex-tile
  tabindex="0"
  libGroupSkip
  [groupSkipContent]="true"
  class="sticky-order-summary checkout-tile udex-mb-84"
  [interactive]="true"
  [href]="'javascript:void(0)'"
>
  <dcp-checkout-order-summary
    [selectedView]="selectedView"
  ></dcp-checkout-order-summary>
  <dcp-po-number
    *ngIf="selectedView == view.CheckOut"
    [componentTexts]="componentTexts"
  ></dcp-po-number>
  <div class="continue-button udex-py-4 d-flex flex-column">
    <dcp-checkout-place-order
      *ngIf="selectedView == view.CheckOut"
      [cartIsLoading]="cartIsLoading"
      [entries]="entries"
    ></dcp-checkout-place-order>
    <ng-container *ngIf="selectedView == view.Cart">
      <a
        class="d-flex flex-grow-1 justify-content-end"
        [class.disabled]="
          (checkoutEntryValidationService.isActiveCartInvalid() | async) ||
          cartIsLoading
        "
        [routerLink]="['/checkout']"
      >
        <udex-button
          class="flex-grow-1 continue-button__button"
          size="Large"
          [disabled]="
            (checkoutEntryValidationService.isActiveCartInvalid() | async) ||
            cartIsLoading
          "
          data-cy="checkout-button"
          type="Button"
        >
          <span *ngIf="showSpinner">
            <ui5-busy-indicator
              size="Medium"
              class="white-dots d-flex"
              active
            ></ui5-busy-indicator>
          </span>
          <span *ngIf="!showSpinner">{{ "cart.checkOut" | cxTranslate }} </span>
        </udex-button>
      </a>
      <div
        class="continue-button__cart__text text-end udex-pt-16 body--xs"
        data-cy="payment-info"
      >
        {{ "cart.paymentInfo" | cxTranslate }}
      </div>
    </ng-container>
    <ng-container *ngIf="selectedView === view.DataEntry">
      <div class="d-flex flex-grow-1 justify-content-end">
        <udex-button
          class="continue-button__button flex-grow-1"
          size="Large"
          data-cy="checkout-button"
          type="Button"
          [disabled]="
            (checkoutEntryValidationService.isActiveCartInvalid() | async) ||
            cartIsLoading ||
            showSpinner
          "
          (mousedown)="checkoutReviewOrder()"
        >
          <span *ngIf="showSpinner" aria-hidden="true" role="status"
            ><ui5-busy-indicator
              size="Medium"
              class="white-dots d-flex"
              active
            ></ui5-busy-indicator>
          </span>
          <span *ngIf="!showSpinner"
            >{{
              "checkout.digitalNativeCheckout.continueToCheckoutReview"
                | cxTranslate
            }}
          </span>
        </udex-button>
      </div>
    </ng-container>
  </div>
  <dcp-cart-coupon
    *ngIf="
      isCouponSectionVisible ||
      ((cartDecoratorErrorHandlingService.promotionRemovedErrorSubject$ | async)
        ?.showError &&
        !isNoCouponPromoError)
    "
    (errorNoCoupon)="onPromoErrorNoCoupon()"
    [selectedView]="selectedView"
  ></dcp-cart-coupon>
</udex-tile>
<dcp-delego-silent-payment
  *ngIf="dcpCcPspService.isDelego(currentPaymentProvider)"
></dcp-delego-silent-payment>
